import React from 'react';
import './Button.css';

const Button = ({ 
  children, 
  variant = 'primary', // primary, secondary, danger, text
  size = 'medium', // small, medium, large
  fullWidth = false,
  disabled = false,
  loading = false,
  onClick,
  type = 'button'
}) => {
  const classes = [
    'ui-button',
    variant === 'primary' ? 'submit-btn' : 'cancel-btn',
    size === 'small' ? 'ui-button--small' : size === 'large' ? 'ui-button--large' : '',
    fullWidth ? 'ui-button--full-width' : '',
    loading ? 'ui-button--loading' : ''
  ].filter(Boolean).join(' ');

  return (
    <button
      className={classes}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
    >
      {loading ? (
        <span className="ui-button__spinner">
          <i className="fas fa-spinner fa-spin"></i>
        </span>
      ) : children}
    </button>
  );
};

export default Button; 